import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from 'vuetify/lib/util/colors'
import ar from 'vuetify/lib/locale/ar'
import en from 'vuetify/lib/locale/en'
import es from 'vuetify/lib/locale/es'
import i18n from '@/i18n/i18n';

Vue.use(Vuetify);

export default new Vuetify({
    rtl: true,
    theme: {
    themes: {
        light: {
			primary:"#0c3b63",//deepskyblue #346f86 #39577d #02855b
			'success-color': '#02855b',
			'success-light-color': "#00c468",
			'danger-color': '#e00c23',
			'danger-dark-color': '#b61211',
			'alert-color': '#f96a02',
			'warning-color': '#f2b914',
			'info-light-color': '#49acfd',
			'info-color': '#3377ff',
			'info-dark-color': '#1457da',
			'preview-color': colors.deepPurple.darken1,
			'edit-color': colors.deepOrange.lighten1,

			addingColor : colors.green.darken1,
			displayingColor : "#006F86",
			editingColor: "#006F86",
			deletingColor : "#D06044",
			blueGreyDarken2 : colors.blueGrey.darken2,
			blueGrayLighten3 : colors.blueGrey.lighten3,
			cachedColor: colors.blue.darken2,
			greyLighten5: colors.grey.lighten5,
			greyLighten1: colors.grey.lighten1,
			blueGray: "#608391",
			greenDarken1 : colors.green.darken1,
			redDarken1 : colors.red.darken1,
			grey: "#9E9E9E",
			chartColor: "#0f4",
			greyDarken2: colors.grey.darken2,
			greyLighten3: colors.grey.lighten3,
			orangeLighten5: colors.orange.lighten5,
			greenLighten5: colors.green.lighten5,
			redLighten5: colors.red.lighten5,
			navPrimary: "#E7F0F7",
			navSecondary: "#FBFBF3",
			postedColor: "#1c8421",
			unpostedColor: "#e00c24",
			whiteBlue: "#f6f8fe",
			whitelilac: "#acafe8", 
			whitePink: "#c9b7dc",
			lilac: "#6354cc",
			offWhite: "#f6f7fd",
			gold: "#d9bd5d",
			active: colors.teal,
			unactive:"#555",
			yellowDarken2: colors.yellow.darken2,
			printingColor: colors.orange.darken2,
			cyanAccent4: colors.cyan.accent4,
        }
    }
    },
	lang: {
		current: i18n.locale,
		locales: {ar, en, es}
	}
});
